module.exports = __webpack_public_path__ + "static/media/sun.80ff645c.svg";